module.exports = __webpack_public_path__ + "img/bookmark.d08ce2fc.svg";